<template>
  <div>
    <!-- List payment late -->
    <div class="box box-success">
      <div>
        <div class="box-header" style="text-align:center;margin:auto;">
          <h3 class="box-title">
            {{ $t("dashboard.statistical_overdue_debts") }}
          </h3>
          <row style="text-align: center;">
            <div style="display: inline-block;">
              <div style="width:110px; margin-top:5px">
                <div class="input-group date">
                  <date-picker
                    ref="periodPicker"
                    v-model="datePickerValue"
                    @dp-change="onHandleChangeMonth(datePickerValue)"
                    :config="optionsPicker"
                    :placeholder="$t('invoice.issuePeriod')"
                  ></date-picker>
                  <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                    <i class="fa fa-caret-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </row>
        </div>
        <div class="box-body">
          <div class="col-md-12">
            <div class="circle-parent">
              <div class="fraction-child">
                <span class="sub-style">{{ total_apartment }}</span>
                <span style="display:block;color:#656565">{{
                  $t("dashboard.apartment")
                }}</span>
              </div>
            </div>
            <div
              style="text-align:center;margin-top: 15px;font-size: 16px;color:#656565"
            >
              <span>{{ $t("dashboard.overdue_debts") }}</span>
            </div>
          </div>
          <!-- <div class="col-md-12" style="margin-top: 50px;">
              <div class="circle-parent-small">
                  <div class="fraction-child-small">
                      <span class="sub-style-small">{{invoice_not_export_yet}}</span>
                      <div>
                          <span>PHIẾU BÁO</span>
                      </div>
                  </div>
              </div>
              <div style="margin-top: 15px;color: darkgray">
                  <span>PHIẾU BÁO CHƯA XUẤT</span>
              </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: "StatisticalInvoice",
  data() {
    return {
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      total_apartment: 0
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    },
    GET_STATISTICAL_APARTMENT_PAYMENT_LATE_DATA: function() {
      let data = this.GET_STATISTICAL_APARTMENT_PAYMENT_LATE_DATA.data;
      if (data) {
        this.total_apartment =
          data.total_apartment_payment_late < 10 &&
          data.total_apartment_payment_late != 0
            ? "0" + data.total_apartment_payment_late
            : data.total_apartment_payment_late;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_LANG",
      "GET_STATISTICAL_APARTMENT_PAYMENT_LATE_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_STATISTICAL_APARTMENT_PAYMENT_LATE"
    ]),
    onHandleChangeMonth: function(value) {
      this.getStatisticalPaymentLater();
    },
    getStatisticalPaymentLater: function() {
      const filter = {
        ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM")
      };
      this.GET_STATISTICAL_APARTMENT_PAYMENT_LATE(filter);
    }
  },
  components: {
    "date-picker": datePicker
  },
  created() {
    this.getStatisticalPaymentLater();
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.circle-parent {
  width: 200px;
  height: 200px;
  border-width: 5px;
  border-style: solid;
  border-radius: 50%;
  position: relative;
  margin: auto;
  border-color: darkgray;
  color: darkgray;
}
.fraction-child {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 25%;
}
.sub-style {
  font-size: 50px;
}
@media (max-width: 1400px) {
  .circle-parent {
    width: 120px;
    height: 120px;
  }
  .sub-style {
    font-size: 25px;
  }
}
@media (max-width: 990px) {
  .circle-parent {
    width: 200px;
    height: 200px;
  }
  .sub-style {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/StatisticalPaymentLate.vue